import React from 'react';
import Layout from 'components/Layout';

import {
  fetchCourseListWithGroupFlow,
  fetchLearningCourseFlow,
} from 'reduxModules/course/saga';
import {
  fetchCourseListWithGroup,
  fetchLearningCourse,
  updateCourseSelectedGradeLevel,
} from 'reduxModules/course/action';
import { getUserIsAuthenticated } from 'reduxModules/user/selector';
import { getCourseHomeFilterInfo } from 'reduxModules/course/selector';

import SnapaskHeader from 'components/SnapaskHeader';
import AlertBanner from 'components/AlertBanner/AlertBanner';
import SnapaskLocaleSelection from 'components/SnapaskLocaleSelection';
import SocialWidgetHandler from 'components/SocialWidgetHandler/SocialWidgetHandler';
import SnapaskFooter from 'components/SnapaskFooter';
import { SNAPASK_SITE_ENDPOINT } from 'config';

import CourseHome from './CourseHome';

async function action(context) {
  const {
    store,
    i18n,
    pathname,
    query: { subjectId, gradeLevelId },
  } = context;
  const tempSubjectId = parseInt(subjectId, 10);
  const tempGradeLevelId = parseInt(gradeLevelId, 10);
  const isAuthenticated = getUserIsAuthenticated(store.getState());
  store.dispatch(
    updateCourseSelectedGradeLevel({
      selectedGradeLevel: tempGradeLevelId || 0,
      selectedSubject: tempSubjectId || 0,
    }),
  );
  const { selectedGradeLevel, selectedSubject } = getCourseHomeFilterInfo(
    store.getState(),
  );

  await Promise.all([
    store
      .runSagas(
        fetchCourseListWithGroupFlow,
        fetchCourseListWithGroup({ selectedGradeLevel, selectedSubject }),
      )
      .toPromise(),
    isAuthenticated &&
      store
        .runSagas(fetchLearningCourseFlow, fetchLearningCourse())
        .toPromise(),
  ]);

  const { title, description, image } = i18n.t('seo.courses', {
    returnObjects: true,
  });

  return {
    title,
    description,
    ogTags: {
      title,
      description,
      image,
      type: 'website',
      url: `${SNAPASK_SITE_ENDPOINT}${pathname}`,
    },
    jsonLDList: [
      {
        '@context': 'https://schema.org',
        '@type': 'instructor',
        image,
        name: title,
        description,
        publisher: {
          '@type': 'Organization',
          name: 'Snapask',
        },
      },
    ],
    chunks: ['courseHome'],
    component: (
      <Layout>
        <SnapaskHeader />
        <AlertBanner />
        <SnapaskLocaleSelection />
        <SocialWidgetHandler />
        <CourseHome />
        <SnapaskFooter />
      </Layout>
    ),
  };
}

export default action;
